module.exports = __webpack_public_path__ + "media/images/emoticons/capricornus-a40195e7874d48f64d3181baa4b190ec.gif";